module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-6364b19b.png";